"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "60.38618mm",
    height: "17.40476mm",
    viewBox: "0 0 171.17342 49.33633"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.45938,35.92317m0,0V48.61646H0V0H7.45938Z",
    fill: "#002542"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M123.6512,40.63388v7.98258h-6.34712l0-1.63548a28.30576,28.30576,0,0,1-10.337,2.35535c-6.54376,0-9.81473-3.66429-9.81473-10.46874,0-6.57577,2.22455-9.90531,10.97981-10.22924l8.05967-.3703v-2.0288c0-3.00936-1.50468-4.38324-4.514-4.38324H100.10705V15.96717h12.54263c7.31982,0,11.00152,4.11246,11.00152,10.27208Zm-14.68985-6.79645c-2.81362.26161-4.28468,2.01989-4.28468,4.8335,0,2.74867,1.17814,4.515,3.86,4.515a37.43891,37.43891,0,0,0,7.65512-1.30894V33.56782Z",
    fill: "#002542"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M58.17938,40.63388v7.98258H51.83226l0-1.63548a28.30576,28.30576,0,0,1-10.337,2.35535c-6.54377,0-9.81473-3.66429-9.81473-10.46874,0-6.57577,2.22455-9.90531,10.97981-10.22924l8.05966-.3703v-2.0288c0-3.00936-1.50468-4.38324-4.514-4.38324H34.63522V15.96717H47.17785c7.31983,0,11.00153,4.11246,11.00153,10.27208ZM43.48952,33.83743c-2.81361.26161-4.28467,2.01989-4.28467,4.8335,0,2.74867,1.17813,4.515,3.86,4.515A37.43876,37.43876,0,0,0,50.72,41.877V33.56782Z",
    fill: "#002542"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M163.714,15.96717h7.45938V48.61646H163.714Z",
    fill: "#002542"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.26151,32.64929h7.76758l9.33779,15.96717H18.59931Z",
    fill: "#ea5153"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.59931,15.96717h7.76757l-9.3378,16.68212H9.26151Z",
    fill: "#002542"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M89.98755,22.071s-7.85178-.45749-11.77767-.45749c-3.86,0-5.43058,1.21022-5.43058,3.69637,0,2.02789,1.37388,2.552,6.80445,3.40177,8.63751,1.37479,11.51607,3.66429,11.51607,10.14219,0,7.65512-4.94247,10.335-12.99,10.335-4.64576,0-11.73848-.55842-11.73848-.55842l.01-6.6503s7.72211.65925,11.05893.65925c4.5799,0,6.20022-.97195,6.20022-3.58982,0-2.09375-1.04642-2.6819-6.28125-3.53257-8.375-1.37388-12.03836-3.206-12.03836-10.01139,0-7.45846,5.823-10.1109,12.36583-10.1109,4.77656,0,12.29433.55869,12.29433.55869Z",
    fill: "#002542"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M155.45984,22.071s-7.85178-.45749-11.77767-.45749c-3.86,0-5.43058,1.21022-5.43058,3.69637,0,2.02789,1.37388,2.552,6.80446,3.40177,8.6375,1.37479,11.51606,3.66429,11.51606,10.14219,0,7.65512-4.94247,10.335-12.99,10.335-4.64576,0-11.73848-.55842-11.73848-.55842l.01-6.6503s7.7221.65925,11.05892.65925c4.5799,0,6.20022-.97195,6.20022-3.58982,0-2.09375-1.04642-2.6819-6.28124-3.53257-8.375-1.37388-12.03837-3.206-12.03837-10.01139,0-7.45846,5.823-10.1109,12.36583-10.1109,4.77656,0,12.29433.55869,12.29433.55869Z",
    fill: "#002542"
  }));
};

exports["default"] = _default;